<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <h1 class="bofa--heading is-4 double-bottom-space">Municipal Banking and
    Markets</h1>
  <form [formGroup]="mbamSurveyForm">

    <div class="bottom-space">
      <!-- radio contributions within 24 months -->
      <div class="max-width max-zoom bottom-space" id="contribution24"><abbr title="required">* </abbr>Have you made any
        political contributions within the
        last 24 months? </div>

      <div class="double-bottom-space max-width">
        <mat-radio-group required aria-describedby="contribution24" formControlName="contribution"
          name="radioContribution">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" matInput value="1">Yes
          </mat-radio-button>
          <mat-radio-button class="minor-radio-padding" matInput value="0">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <mat-error *ngIf="submit.value && contribution.hasError('required')">Please select
      Have you made any political contributions within the last 24 months?</mat-error>

    <!-- Hidden divs are for screen readers -->
    <div class="bofa--skiplink">
      <mat-error *ngIf="hasBeenSubmittted && showContribution">Please select
        Have you made any political contributions within the last 24 months?</mat-error>
    </div>

    <div *ngIf="contribution.value == 1">

      <h2 class="bofa--heading is-7 has-text-centered"><strong>BANK OF AMERICA MERRILL LYNCH MUNICIPAL BANKING AND
          MARKETS <br aria-hidden="true" />TRANSFER/PRE-EMPLOYMENT POLITICAL CONTRIBUTION AND OUTSIDE INTEREST
          DISCLOSURE
          <br aria-hidden="true" />CERTIFICATION</strong></h2>

      <p>Various regulations, including Municipal Securities Rulemaking Board Rule G-37, as well as various U.S. state
        and local statutes, govern the
        activities of financial institutions and certain of their employees relative to Political Contributions. These
        rules can provide for firm-wide
        bans on entering into various categories of banking relationships or transactions with governmental entities if
        a Political
        Contribution in excess of <em>de minimis</em> amounts is made by a covered employee to a political candidate,
        political party committee, or
        political action committee. These include Political Contributions made before an individual becomes an employee
        of the financial institution.</p>

      <p>To ensure its compliance with such rules, BofAML must request disclosure of certain information regarding
        Political Contributions
        that you may have made to political candidates within the U.S. (including at the federal, state, or local
        levels), as well as Political
        Contributions or payments that you may have made to political action committees or political parties, within the
        past two years.</p>

      <p>Please read the certification below, provide any details necessary to make the certification accurate, and sign
        and date the form.
        Thank you for your assistance.</p>


      <h3 class="bofa--heading is-7"><strong>Certification</strong></h3>
      <p><strong>I hereby certify that I made no Political Contributions within the past two years, directly or
          indirectly, except as disclosed below.</strong></p>

      <h4 class="bofa--heading is-8"><strong>Outside Interest Disclosure (If you answer yes to any of the following
          questions please provide details.)</strong></h4>

      <!-- radio question 1 -->
      <div class="max-width max-zoom bottom-space" id="question1"><abbr title="required">* </abbr>Do you have any
        outside employment, business interests or private placement participations? </div>

      <div class="bottom-space max-width">
        <mat-radio-group required aria-describedby="question1" formControlName="mbamOutsideEmployment">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" matInput value="1">Yes
          </mat-radio-button>
          <mat-radio-button class="minor-radio-padding" matInput value="0">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-error class="bottom-space" *ngIf="submit.value && mbamOutsideEmployment.hasError('required')">Please select
        Do you have any
        outside employment, business interests or private placement participations?</mat-error>

      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmittted && showRadioOutsideEmployment">Please select Do you have any
          outside employment, business interests or private placement participations?</mat-error>
      </div>

      <!-- radio question 2 -->
      <div class="max-width max-zoom bottom-space" id="question2"><abbr title="required">* </abbr>Are you a director,
        advisory director, board member or officer of
        any publicly traded or private company or a charitable or other non-profit organization? </div>

      <div class="bottom-space max-width">
        <mat-radio-group required aria-describedby="question2" formControlName="mbamMemberCompany">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" matInput value="1">Yes
          </mat-radio-button>
          <mat-radio-button class="minor-radio-padding" matInput value="0">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-error class="bottom-space" *ngIf="submit.value && mbamMemberCompany.hasError('required')">Please select Are
        you a director,
        advisory director, board member or officer of
        any publicly traded or private company or a charitable or other non-profit organization?</mat-error>


      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmittted && showMemberCompany">Please select Are you a director,
          advisory director, board member or officer of
          any publicly traded or private company or a charitable or other non-profit organization?</mat-error>
      </div>

      <!-- radio question 3 -->
      <div class="max-width max-zoom bottom-space" id="question3"><abbr title="required">* </abbr>Are you an elected or
        appointed public official?</div>

      <div class="bottom-space max-width">
        <mat-radio-group required aria-describedby="question3" formControlName="mbamElectedOfficial">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" matInput value="1">Yes
          </mat-radio-button>
          <mat-radio-button class="minor-radio-padding" matInput value="0">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-error class="bottom-space" *ngIf="submit.value && mbamElectedOfficial.hasError('required')">Please select Are
        you an elected or
        appointed public official?</mat-error>


      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmittted && showElectedOfficial">Are you an elected or
          appointed public official?</mat-error>
      </div>

      <!-- radio question 4 -->
      <div class="max-width max-zoom bottom-space" id="question4"><abbr title="required">* </abbr>Are you an officer,
        director or a member of any committees or
        advisory panels of any regulatory bodies, industry trade, or professional organization?</div>

      <div class="bottom-space max-width">
        <mat-radio-group required aria-describedby="question4" formControlName="mbamMemberCommitee">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" matInput value="1">Yes
          </mat-radio-button>
          <mat-radio-button class="minor-radio-padding" matInput value="0">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-error class="bottom-space" *ngIf="submit.value && mbamMemberCommitee.hasError('required')">Please select Are
        you an officer,
        director or a member of any committees or
        advisory panels of any regulatory bodies, industry trade, or professional organization?</mat-error>


      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmittted && showMemberCommitee">Please select Are you an officer,
          director or a member of any committees or
          advisory panels of any regulatory bodies, industry trade, or professional organization?</mat-error>
      </div>

      <!-- any above are yes requires comment / textarea -->
      <div *ngIf="mbamOutsideEmployment.value == 1 || mbamMemberCompany.value == 1 ||
          mbamElectedOfficial.value == 1 || mbamMemberCommitee.value == 1" class="bottom-space max-width">
        <mat-form-field class="max-zoom field-space width-marginbottom" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Please provide details</mat-label>
          <textarea matInput formControlName="mbamComment" required></textarea>
          <mat-error>Please provide details</mat-error>
        </mat-form-field>
      </div>

      <!-- contributions -->
      <div class="double-bottom-space">
        <div>
          <div class="flex-40">
            <h3 class="bofa--heading is-5">Contribution</h3>
          </div>
          <div class="flex-60">
            <div *ngIf="pcCandidateList.length === 0" class="padding-top pad-left5"> <button
                [disabled]="pcCandidateList.invalid" #addButtonElement type="button" class="bofa--button secondary"
                (click)="createContribution('')">Add Contribution</button>
            </div>
          </div>
        </div>

        <!-- set focus when pressing Remove button -->
        <div *ngIf="!pcCandidateList.invalid" tabindex="-1" #addElement class="bofa--skiplink">
        </div>

        <div>
          <ng-container *ngFor="let contributionForm of pcCandidateList.controls; let i = index"
            [formGroup]="contributionForm" class="double-bottom-space">
            <mat-card appearance="outlined"
              class="af-mat-card mat-elevation-z flex-change double-bottom-space mat-card-padding"
              [class.border]="blueBorder" [class.border-red]="redBorder">

              <!-- set focus when pressing Add button -->
              <div *ngIf="contributionForm.invalid" tabindex="-1" #addElement class="bofa--skiplink">
              </div>

              <div class="item-display bottom-space">
                <mat-form-field class="max-width width-350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Name of Recipient</mat-label>
                  <input matInput formControlName="recipientName" required>
                  <mat-error>Please enter Name of Recipient</mat-error>
                </mat-form-field>

                <mat-form-field class="max-width width-350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Amount of Contribution</mat-label>
                  <input matInput formControlName="amount" required>
                  <mat-error>Please enter Amount of Contribution</mat-error>
                </mat-form-field>
              </div>

              <div class="label-padding">
                <label class="minor-label-padding max-width width-450" id="principalLongLabel"><abbr title="required">*
                  </abbr>Your Principal Address at Time of Contribution</label>
                <mat-form-field class="max-width width-450" hideRequiredMarker aria-describedby="principalLongLabel">
                  <input matInput formControlName="address" required>
                  <mat-error>Please enter Your Principal Address at Time of Contribution</mat-error>
                </mat-form-field>
              </div>

              <div class="item-display bottom-space">
                <mat-form-field class="max-width width-350" hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>Date of Contribution</mat-label>
                  <input matInput [matDatepicker]="contributionDatePicker" formControlName="contributionDate" required>
                  <mat-datepicker-toggle matSuffix [for]="contributionDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #contributionDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error>Please enter Date of Contribution mm/dd/yyyy</mat-error>
                </mat-form-field>
              </div>

              <div class="label-padding">
                <label class="minor-label-padding max-width width-650" id="officeLongLabel"><abbr title="required">*
                  </abbr>Political Office Held by Candidate or Office Sought at Time of Contribution</label>
                <mat-form-field class="max-width width-650" hideRequiredMarker aria-describedby="officeLongLabel">
                  <input matInput formControlName="officeRunning" required>
                  <mat-error>Political Office Held by Candidate or Office Sought at Time
                    of Contribution</mat-error>
                </mat-form-field>

                <div class="is-taller top-space">
                  <button type="button" class="bofa--button primary outlined" (click)="deleteClick(i)">Remove this
                    Contribution</button>
                </div>
              </div>
            </mat-card>
          </ng-container>
        </div>
      </div>

      <div *ngIf="pcCandidateList.length !== 0" class="double-bottom-space">
        <button [disabled]="pcCandidateList.invalid" type="button"
          class="bofa--button secondary marginright-marginleft-block" (click)="createContribution('click')">Add
          Contribution</button>
      </div>

      <!-- wet signature -->
      <p class="bofa--heading is-8">By signing below you acknowledge that you have fully reviewed and completed the
        information above</p>

      <div class="width750-marginbottom-margintop" *ngIf="mbamSurveyData">
        <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)">
        </app-wet-signature>
        <mat-error *ngIf="pcMbamSignature.hasError('invalid') || sigCheckValue"> Please enter electronic
          signature </mat-error>
      </div>

      <div class="is-taller">
        <mat-checkbox aria-required="true" required formControlName="pcMbamAccepted" class="minor-check-padding"
          (focusout)="confirmOnBlur()" (focusin)="confirmOnFocus()">
          <mat-label class="whitespace-normal"><abbr title="required">* </abbr>Yes, I agree that I have fully
            reviewed and completed the information above
          </mat-label>
        </mat-checkbox>
        <mat-error class="whitespace-normal-margintop" *ngIf="pcMbamAccepted.hasError('invalid') && check">
          Please check
          the box to agree to the above language </mat-error>
      </div>

      <div>
        <mat-form-field class="max-zoom width350-marginbottom-margintop" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
          <input matInput placeholder="Full name" formControlName="pcMbamSignedName" required maxlength="250">
          <mat-error>Please enter your full name</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field class="max-zoom width-350">
          <mat-label>Date Signed</mat-label>
          <input value="{{ date }}" matInput disabled>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field class="max-zoom width-350-marginbottom" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Enter line of business/group</mat-label>
          <input matInput placeholder="Group" formControlName="pcGroup" required maxlength="250">
          <mat-error>Please enter line of business/group</mat-error>
        </mat-form-field>
      </div>

    </div>

    <p>
      * A “Political Contribution” includes any gift, subscription, loan, advance, or deposit of money or any thing of
      value made for
      the purpose of influencing any election for federal, state, or local office; for payment or reduction of debt
      incurred in connection with any such election; or for transition or inaugural expenses for a successful candidate.
      These include
      contributions made to candidates for elected office, political parties, political action committees, and any other
      entities
      organized under Section 527 of the Internal Revenue Code.
    </p>

  </form>
</div>